<template>
  <v-container grid-list-xl fluid>
    <div v-if="load" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-form
      v-if="!load"
      ref="form"
      v-model="form.valid"
      lazy-validation
      grid-list-md
    >
      <v-card>
        <v-toolbar :elevation="0" dense color="transparent">
          <v-toolbar-title>
            <h4>Dados Cadastrais da Indústria</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.name"
                :counter="255"
                :rules="form.nameRules"
                label="Nome fantasia"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.name_official"
                label="Razão Social"
                :rules="form.name_officialRules"
                :counter="255"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.document_number"
                label="CNPJ"
                :rules="form.document_numberRules"
                required
                mask="##.###.###/####-##"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.ie"
                label="Inscrição Estadual"
                :rules="form.ieRules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.email"
                label="E-mail"
                :counter="255"
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.phone"
                label="Telefone com DDI e DDD"
              ></v-text-field>
            </v-flex>

            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.partner_id"
                label="Hash partner Blockchain"
                type="text"
              ></v-text-field>
            </v-flex>

            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.personal_phone"
                v-mask="'+## (##) #####-####'"
                :rules="form.phoneRules"
                label="Whatsapp"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.url_chatbot"
                label="URL Chatbot"
                type="text"
              ></v-text-field>
            </v-flex>

            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.webservices_key"
                label="Webservices key"
                type="text"
              ></v-text-field>
            </v-flex>

            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.qrcode_nickname"
                label="Nickname QRCODE"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex md4 xs12>
              <v-row justify="center">
                <v-col sm="11">
                  <v-row>
                    <v-switch
                      label="Flag - Blockchain"
                      v-model="industry.blockchain_flag"
                      :value="industry.blockchain_flag"
                      hide-details
                    ></v-switch>
                  </v-row>
                  <v-row>
                    <v-switch
                      label="Recebimento de PDF"
                      v-model="industry.pdf_notification"
                      :value="industry.pdf_notification"
                      hide-details
                    ></v-switch>
                  </v-row>
                </v-col>
              </v-row>
            </v-flex>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.email_template"
                label="Template e-mail"
                type="text"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <div v-if="previewImage">
                <v-img
                  :src="previewImage"
                  :height="100"
                  :contain="true"
                  alt="Logo"
                ></v-img>
              </div>
            </v-flex>
            <v-flex xs8>
              <v-file-input
                @change="getPreviewImage"
                accept="image/png, image/jpeg"
                prepend-icon="fa-camera"
                label="Enviar logo"
              ></v-file-input>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <br />

      <v-card>
        <v-toolbar :elevation="0" dense color="transparent">
          <v-toolbar-title>
            <h4>Endereço de Correspondência</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex md4 xs12>
              <v-text-field
                v-model="industry.address_zipcode"
                label="CEP"
                :rules="form.address_zipcodeRules"
                required
                mask="#####-###"
                @change="findCep"
              ></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                v-model="industry.address_street"
                label="Logradouro"
                :rules="form.address_streetRules"
                :counter="255"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md2 xs12>
              <v-text-field
                v-model="industry.address_number"
                label="Número"
                :rules="form.address_numberRules"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-text-field
                v-model="industry.address_compl"
                label="Complemento"
                :rules="form.address_complRules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                v-model="industry.address_neighborhood"
                label="Bairro"
                :rules="form.address_neighborhoodRules"
                :counter="255"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                v-model="industry.address_city"
                label="Cidade"
                :rules="form.address_cityRules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-select
                v-model="industry.address_state"
                :items="states"
                label="Estado"
                item-text="name"
                item-value="initial"
                required
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 xs12>
              <v-text-field
                v-model="industry.latitude"
                :rules="form.latitudeRules"
                label="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                v-model="industry.longitude"
                label="Longitude"
                :rules="form.longitudeRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <br />

      <v-card>
        <v-toolbar :elevation="0" dense color="transparent">
          <v-toolbar-title>
            <h4>Observação</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-textarea
                v-model="industry.obd"
                :rules="form.obdRules"
                label
                :counter="255"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <br />

      <app-confirm-modal
        message="Você tem certeza que quer deletar?"
        :dialog="dialogDeleteCamera"
        modalType="error"
        v-on:choose="deleteCamera"
      />

      <v-card>
        <v-toolbar :elevation="0" dense color="transparent">
          <v-toolbar-title>
            <h4>Câmeras</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-col v-for="(cam, idx) in industry.cameras" :key="idx">
            <v-card>
              <v-card-text>
                <v-row>
                  <div
                    class="mx-4 py-5 d-flex flex-column justify-space-between"
                  >
                    <v-btn
                      text
                      icon
                      :disabled="industry.cameras.length === 0 || idx === 0"
                      color="blue"
                      small
                      @click="moveItem(idx, 'up')"
                    >
                      <v-icon size="35">fas fa-arrow-up</v-icon>
                    </v-btn>
                    <v-btn
                      text
                      icon
                      :disabled="
                        industry.cameras.length === 0 ||
                          idx === industry.cameras.length - 1
                      "
                      color="blue"
                      small
                      @click="moveItem(idx, 'down')"
                    >
                      <v-icon size="35">fas fa-arrow-down</v-icon>
                    </v-btn>
                  </div>
                  <v-col cols="11">
                    <v-row no-gutters class="mt-5" align="center">
                      <h2 class="mx-2">Câmera {{ idx + 1 }}</h2>
                      <v-btn
                        text
                        icon
                        color="pink"
                        small
                        @click="deleteCameraRequest(idx)"
                      >
                        <v-icon size="30">fa-trash</v-icon>
                      </v-btn>
                    </v-row>
                    <v-row class="pb-5">
                      <v-col align-self="center" lg="2" md="2" cols="12">
                        <v-text-field
                          type="number"
                          :rules="[v => !!v || 'Obrigatório']"
                          v-model="cam.local_id"
                          label="Id do local da câmera (*)"
                        ></v-text-field>
                      </v-col>
                      <v-col align-self="center" lg="4" md="4" cols="12">
                        <v-text-field
                          type="text"
                          :rules="[v => !!v || 'Obrigatório']"
                          v-model="cam.camera_name"
                          :counter="255"
                          label="Nome (*)"
                        ></v-text-field>
                      </v-col>
                      <v-col align-self="center" lg="4" md="4" cols="12">
                        <v-text-field
                          :rules="[v => !!v || 'Obrigatório']"
                          v-model="cam.stream_name"
                          type="text"
                          :counter="255"
                          label="Nome da Stream (*)"
                        ></v-text-field>
                      </v-col>
                      <v-col class="pa-0 ml-5">
                        <v-row no-gutters>
                          <v-switch
                            label="Ativar ou desativar"
                            v-model="cam.is_active"
                            :value="cam.is_active"
                            hide-details
                          ></v-switch>
                          <v-switch
                            label="Enviar notificação"
                            v-model="cam.should_send_notification"
                            :value="cam.should_send_notification"
                            hide-details
                          ></v-switch>
                          <!-- <v-switch
                            label="Abrir por padrão"
                            v-model="cam.is_default"
                            :value="cam.is_default"
                            hide-details
                          ></v-switch> -->
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-layout row wrap>
            <v-flex xs12>
              <v-btn color="primary" @click="addIndustryCamera" small>
                <span>
                  <v-icon class="mr-3">fa-plus</v-icon>Adicionar Câmera
                </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-row justify="center">
        <v-col sm="8" md="6" lg="2">
          <v-btn
            block
            :disabled="!form.valid ? true : form.valid && saving ? true : false"
            color="success"
            @click="saveIndustry"
          >
            Salvar
            <v-progress-circular
              v-if="saving"
              :size="20"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import appApi from "../../plugins/api";
import FindCep from "../../plugins/find-cep";

import ConfirmModal from "../../components/ConfirmModal";

import { setTimeout } from "timers";

const defaultCameras = [
  {
    local_id: 50,
    camera_name: "Peso Vivo",
    stream_name: "stream_peso_vivo",
    should_send_notification: false,
    // is_default: false,
    is_active: true
  },
  {
    local_id: 100,
    camera_name: "Dorso",
    stream_name: "stream_dorso",
    should_send_notification: false,
    // is_default: true,
    is_active: true
  },
  {
    local_id: 200,
    camera_name: "Pagadoria",
    stream_name: "stream_pagadoria",
    should_send_notification: false,
    // is_default: false,
    is_active: true
  }
];

export default {
  components: {
    "app-confirm-modal": ConfirmModal
  },

  data: function() {
    return {
      dialogDeleteCamera: false,
      selectedCameraToDelete: null,

      id: null,
      saving: false,
      load: true,
      previewImage: null,
      fileLogo: null,
      industry: {
        cameras: defaultCameras,

        id: null,
        name: "",
        name_official: "",
        track_id: "",
        document_type: "",
        document_number: "",
        email: "",
        latitude: "",
        longitude: "",
        logo: "",
        obd: "",
        ie: "",
        phone: "",

        partner_id: "",
        blockchain_flag: false,
        personal_phone: "",
        url_chatbot: "",
        webservices_key: "",
        qrcode_nickname: "",
        email_template: "",

        address_city: "",
        address_compl: "",
        address_neighborhood: "",
        address_number: "",
        address_state: "",
        address_street: "",
        address_zipcode: "",

        database_db: "",
        database_password: "",
        database_user: "",
        database_host: ""
      },
      form: {
        valid: true,
        nameRules: [
          v => !!v || "Nome fantasia",
          v =>
            (v && v.length <= 255) ||
            "Nome fantasia tem que ter menos de 255 caracteres"
        ],
        name_officialRules: [
          v => !!v || "Razão social é obrigatório",
          v =>
            (v && v.length <= 255) ||
            "Razão social tem que ter menos de 255 caracteres"
        ],
        document_numberRules: [
          v => !!v || "CNPJ é obrigatório",
          v => (v && v.length === 14) || "CNPJ inválido"
        ],
        emailRules: [
          v =>
            (v.length > 0 && /.+@.+/.test(v) === true) || "E-mail é obrigatório"
        ]
      },
      snackbar: {},
      states: [
        { name: "Acre", initial: "AC" },
        { name: "Alagoas", initial: "AL" },
        { name: "Amapá", initial: "AP" },
        { name: "Amazonas", initial: "AM" },
        { name: "Bahia", initial: "BA" },
        { name: "Ceará", initial: "CE" },
        { name: "Distrito Federal", initial: "DF" },
        { name: "Espírito Santo", initial: "ES" },
        { name: "Goiás", initial: "GO" },
        { name: "Maranhão", initial: "MA" },
        { name: "Mato Grosso", initial: "MT" },
        { name: "Mato Grosso do Sul", initial: "MS" },
        { name: "Minas Gerais", initial: "MG" },
        { name: "Pará", initial: "PA" },
        { name: "Paraíba", initial: "PB" },
        { name: "Paraná", initial: "PR" },
        { name: "Pernambuco", initial: "PE" },
        { name: "Piauí", initial: "PI" },
        { name: "Rio de Janeiro", initial: "RJ" },
        { name: "Rio Grande do Norte", initial: "RN" },
        { name: "Rio Grande do Sul", initial: "RS" },
        { name: "Rondônia", initial: "RO" },
        { name: "Roraima", initial: "RR" },
        { name: "Santa Catarina", initial: "SC" },
        { name: "São Paulo", initial: "SP" },
        { name: "Sergipe", initial: "SE" },
        { name: "Tocantins", initial: "TO" }
      ]
    };
  },

  computed: {},

  mounted: function() {
    if (this.$route.params.id) {
      appApi.getIndustry(this.$route.params.id).then(result => {
        this.id = result.data.id;
        this.industry = result.data;

        if (!result.data.cameras || result.data.cameras.length === 0)
          this.industry["cameras"] = defaultCameras;

        this.industry.cameras.sort((a, b) => a.index - b.index);

        this.load = false;
        this.previewImage = this.industry.logo;
      });
    } else {
      this.load = false;
    }
  },

  methods: {
    deleteCameraRequest(idx) {
      if (!this.industry.cameras[idx].id) {
        this.industry.cameras.splice(idx, 1);
        this.$forceUpdate();
        return;
      }

      this.selectedCameraToDelete = this.industry.cameras[idx];
      this.dialogDeleteCamera = true;
    },

    moveItem(currentIndex, direction) {
      let desiredIndex;
      let oldIndex = currentIndex;

      switch (direction) {
        case "up":
          desiredIndex = currentIndex - 1;
          break;

        case "down":
          desiredIndex = currentIndex + 1;
          break;

        default:
          return;
      }

      const oldItem = this.industry.cameras[oldIndex];
      const newItem = this.industry.cameras[desiredIndex];

      this.industry.cameras[desiredIndex] = { ...oldItem };
      this.industry.cameras[oldIndex] = { ...newItem };

      this.$forceUpdate();
    },

    async deleteCamera(answer) {
      if (answer) {
        const idx = this.industry.cameras.findIndex(
          e => e.id === this.selectedCameraToDelete.id
        );

        const { id } = this.industry.cameras[idx];

        await appApi.deleteIndustryCamera(id).catch(this.handleError);

        this.industry.cameras.splice(idx, 1);
      }

      this.dialogDeleteCamera = false;
    },

    addIndustryCamera() {
      if (!this.industry.cameras) this.industry.cameras = [];

      this.industry.cameras.push({
        local_id: 1,
        camera_name: "Nome da camera",
        should_send_notification: false,
        is_active: true,
        // is_default: false,
        stream_name: "Nome da stream"
      });

      this.$forceUpdate();
    },

    saveIndustry() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        let method;

        if (this.$route.params.id) method = "putIndustry";
        else method = "postIndustry";

        appApi[method]({
          id: this.industry.id,
          ...this.industry,
          pdf_notification: this.industry.pdf_notification || false
        })
          .then(this.saveIndustryCameras)
          .then(this.setCamerasIds)
          .then(this.saveIndustryLogo)
          .then(this.successMesage)
          .catch(this.handleError);
      }
    },

    async setCamerasIds(promises) {
      for (const promise of promises) {
        const { data: camera } = promise;

        const cameraIndex = this.industry.cameras.findIndex(
          cam => cam.local_id == camera.local_id
        );

        if (cameraIndex > -1)
          this.industry.cameras[cameraIndex] = {
            ...camera
          };
      }
    },

    saveIndustryLogo() {
      if (this.fileLogo) {
        let formData = new FormData();
        formData.append("logo", this.fileLogo);
        return appApi.postIndustryLogo(this.id, formData);
      }
    },

    saveIndustryCameras({ data: industry }) {
      let promises = [];
      for (const index in this.industry.cameras) {
        const camera = this.industry.cameras[index];

        let promise = camera.id
          ? appApi.putIndustryCamera(camera.id, {
              ...camera,
              index,
              industry_id: industry.id
            })
          : appApi.postIndustryCameras({
              ...camera,
              index,
              industry_id: industry.id
            });

        promises.push(promise);
      }

      this.id = industry.id;

      return Promise.all(promises);
    },
    getPreviewImage(fileInput) {
      if (fileInput) {
        const reader = new FileReader();
        reader.onload = e => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(fileInput);
        this.fileLogo = fileInput;
      } else {
        this.previewImage = null;
        this.fileLogo = null;
      }
    },

    successMesage() {
      if (!this.$route.params.id) {
        setTimeout(() => {
          this.$router.push({
            name: "IndustryEdit",
            params: { id: this.id }
          });
        }, 2000);
      }

      this.saving = false;
      this.snackbar = {
        show: true,
        color: "green",
        text: "Salvo com sucesso."
      };
    },

    handleError(err) {
      console.log(err);
      this.saving = false;
      this.snackbar = {
        show: true,
        color: "error",
        text: "Erro ao salvar, por favor verique os erros."
      };
    },

    findCep() {
      if ((this.industry.address_zipcode + "").length === 8) {
        const that = this;
        FindCep.getAddress(this.industry.address_zipcode, function(resp) {
          that.industry.address_city = resp.address_city;
          that.industry.address_neighborhood = resp.address_neighborhood;
          that.industry.address_street = resp.address_street;
          that.industry.address_state = resp.address_state;
        });
      }
    }
  }
};
</script>
<style scoped lang="css"></style>
